import React, { useState } from 'react';
import Price from '../../atoms/Price';
import Slider from '../../atoms/Slider';
const PriceRange = ({ className, formatter, max, min, onChange, onEnd, testId = 'store-price-range', variant, 'aria-label': ariaLabel, }) => {
    const [edges, setEdges] = useState({ min: min.selected, max: max.selected });
    return (React.createElement("div", { "data-store-price-range": true, "data-testid": testId, className: className },
        React.createElement(Slider, { min: min, max: max, onEnd: onEnd, onChange: (value) => {
                setEdges(value);
                onChange?.(value);
            }, "aria-label": ariaLabel }),
        React.createElement("div", { "data-price-range-values": true },
            React.createElement(Price, { formatter: formatter, "data-price-range-value": "min", value: edges.min, variant: variant }),
            React.createElement(Price, { formatter: formatter, "data-price-range-value": "max", value: edges.max, variant: variant }))));
};
export default PriceRange;
//# sourceMappingURL=PriceRange.js.map